module.exports = __webpack_public_path__ + "static/img/版头设计-3D渲染类版头.52145cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10002/版头设计-3D渲染类版头.png
// module id = 4Z9r
// module chunks = 1